
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      default: 'modulecomp',
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      regionClicked : 'cart/getRegionClicked'
    }),
  },
}
